import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-template5',
  templateUrl: './template5.component.html',
  styleUrls: ['./template5.component.scss']
})
export class Template5Component implements OnInit {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef }) sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {
    // if (this.data && Array.isArray(this.data.experience)) {
    //   this.data.experience.forEach(exp => {
    //     exp.descriptionPoints = exp.description
    //       ? exp.description.split(/\.(?!\d)/)
    //           .map(point => point.trim())
    //           .filter(point => point.length > 0)
    //       : [];
    //   });
    // }
  }

  get skillsInRows() {
    const rows = [];
    for (let i = 0; i < this.data.skills.length; i += 2) {
      rows.push(this.data.skills.slice(i, i + 2));
    }
    return rows;
  }
}
